import Intro from '@/modules/spotlight/pages/Intro.vue';
import ReportRequest from '@/modules/spotlight/pages/ReportRequest.vue';
import Confirmation from '@/modules/spotlight/pages/Confirmation.vue';
import Categories from '@/modules/spotlight/pages/Categories.vue';
import SpotlightErrorPage from '@/modules/spotlight/pages/Error.vue';

// Sub routes
import CategoriesRoutes from '@/modules/spotlight/router/categories';
import ProductDetails from '@/modules/spotlight/pages/ProductDetails.vue';

import FeaturesRoutes from '@/modules/spotlight/router/categories/features';
import HighlightsRoutes from '@/modules/spotlight/router/categories/highlights';
import ProtectionRoutes from '@/modules/spotlight/router/categories/protection';

const GetReport = () => import('@/modules/spotlight/pages/GetReport.vue');
const ReportSent = () => import('@/modules/spotlight/pages/ReportSent.vue');

export const buildRoutesByDevice = (device = 'mobile') => [
  {
    path: '',
    redirect: { path: 'intro' },
  },
  {
    path: 'intro',
    name: `spotlight-intro-${device}`,
    component: Intro,
    meta: {
      headerIcon: 'home',
      hasSxmHeader: true,
    },
  },
  {
    path: 'report-request',
    name: `spotlight-report-request-${device}`,
    component: ReportRequest,
    meta: {
      headerIcon: 'back',
      hasSxmHeader: true,
    },
  },
  {
    path: 'confirmation',
    name: `spotlight-confirmation-${device}`,
    component: Confirmation,
    meta: {
      headerIcon: 'home',
      hasSxmHeader: true,
    },
  },
  {
    path: 'error',
    name: `spotlight-error-${device}`,
    component: SpotlightErrorPage,
    meta: {
      errorType: 'spotlight',
      headerIcon: 'home',
    },
  },
  /**
   * New routes
   */
  {
    path: 'get-report',
    component: GetReport,
    meta: {
      headerIcon: 'back',
    },
  },
  {
    path: 'report-sent',
    component: ReportSent,
    meta: {
      headerIcon: 'home',
    },
  },
  {
    path: 'categories',
    component: Categories,
    meta: {
      headerIcon: 'back',
    },
    children: CategoriesRoutes,
  },
  {
    path: 'categories/features',
    component: ProductDetails,
    meta: {
      headerIcon: 'back',
    },
    children: FeaturesRoutes,
  },
  {
    path: 'categories/highlights',
    component: ProductDetails,
    meta: {
      headerIcon: 'back',
    },
    children: HighlightsRoutes,
  },
  {
    path: 'categories/protection',
    component: ProductDetails,
    meta: {
      headerIcon: 'back',
    },
    children: ProtectionRoutes,
  },
  {
    path: '*',
    redirect: 'error',
  },
];
